
const SudokuGrid = require('../classes/SudokuGrid');

const states = [
    '6_8_5_0_0_0_0_3_2_0_0_9_0_5_8_0_0_4_0_0_0_0_0_2_5_0_8_0_0_6_0_3_5_0_7_0_0_0_0_0_0_6_0_0_0_4_0_3_0_0_1_2_0_0_0_0_0_8_6_0_0_0_5_5_6_8_0_0_0_0_2_0_0_9_7_5_2_0_0_0_0'
];

(() => {
    console.log('Loaded');

    const grids = [];
    document.querySelectorAll('.sudoku-grid').forEach((el, i) => {
        const grid = new SudokuGrid(el);
        grid.loadState(states[i] || '');
        grids.push(grid);
    });

    window.grids = grids;
})();

